import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import isEqual from 'lodash/isEqual';
import { ABTestVariants } from 'sharedModels/ab-test-variants';
import { BehaviorSubject, Observable } from 'rxjs';

declare global {
    interface Window {
        ab_test_variants: ABTestVariants;
    }
}

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class WindowABTestVariantService {
    private currentValue: ABTestVariants;
    private variantChanged$ = new BehaviorSubject<boolean>(false);

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        if (isPlatformBrowser(this.platformId)) {
            this.currentValue = { ...window.ab_test_variants }; // Initialize with current value
            this.initializeSetter();
        }
    }

    private initializeSetter() {
        Object.defineProperty(window, 'ab_test_variants', {
            //Setter intercepts attempts to assign a new value (newValue) to window.ab_test_variants.
            //If a new value is detected, we signal that it has changed.
            set: (newValue: ABTestVariants) => {
                const oldValue = this.currentValue;
                this.currentValue = newValue;

                // Check if the value has changed
                const hasChanged = !isEqual(oldValue, this.currentValue);
                this.variantChanged$.next(hasChanged);
            },
            //Getter assigns the new value to window.ab_test_variants
            get: () => {
                return this.currentValue;
            },
        });
    }

    variantHasChanged$(): Observable<boolean> {
        return this.variantChanged$;
    }
}
